<template>
  <v-container fluid class="pa-0">
    <dual-prevew-list :hideList1="false" :hideList2="onlycus || PreviewCustomer != null"
      :hidePreview1="!PreviewCustomer && !$route.query.customerId" :hidePreview2="true">

      <template v-slot:list1>
        <customer-list :searchStartCharLimit="3"></customer-list>
      </template>

      <template v-slot:list2>
        <MachinePickerPane :preSelected="selectedMachines" :multiple="false" :closeable="false"
          :onCreated="item => selectMachine(item)" @select="sf => select(sf)">
        </MachinePickerPane>
      </template>

      <template v-slot:preview1>
        <preview-customer :id="PreviewCustomer.Id"></preview-customer>
      </template>

    </dual-prevew-list>
  </v-container>
</template>


<script>
import DualPrevewList from "@/views/layouts/DualPrevewList.vue";
import PreviewCustomer from "@/views/job/newjob/cards/customer/PreviewCustomer.vue";
import CustomerList from "@/views/job/newjob/cards/customer/CustomerList.vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import MachinePickerPane from "@/views/job/newjob/cards/machines/MachinePickerPane2.vue";

export default {
  name: "NewJobStart",
  components: {
    DualPrevewList,
    PreviewCustomer,
    CustomerList,
    MachinePickerPane,
  },
  mixins: [clientAPI],

  data() {
    return {
      onlycus: false,
      selectedMachines: [],
    };
  },

  mounted() {
    this.getMode();
    this.$store.dispatch("JobHub/clearJob");
  },

  methods: {
    getMode() {
      var mode = this.$route.query.mode;
      if (mode === "cus") {
        this.onlycus = true;
      }
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: Object.assign({}, this.$route.query, { mode: undefined }),
      });
    },

    async select(selectionFilter) {
      //currently only support single select to avoid complex logic for filtering the list actively 
      // to prevent cross customer machine from being selected
      var machineList = await clientAPI.methods.gatherMachineListFromSelection(selectionFilter);
      this.selectMachine(machineList[0]);
    },

    selectMachine(item) {
      if (!this.selectedMachines?.includes(item.Id)) {
        if (!this.Customer) {
          this.$store.dispatch("JobHub/JobCustomer/getCustomer", item.CustomerId);
        }
        var fiveMinutes = (5 * 60 * 1000);
        var isOld = (new Date() - item.fetched) > fiveMinutes;
        if (isOld) {
          this.$store.dispatch("JobHub/JobSubjobs/getMachineAndAddSubjob", item.Id);
        }
        else {
          this.$store.dispatch("JobHub/JobSubjobs/addMachineAsSubjob", item);
        }
      }
      this.$emit("Close");
      if (this.$route.name === "NewJobStart") {
        //console.log("NewJobStart: selectMachine: ", item);
        this.$router.push({ name: "NewJobOverview" });
      }
    },
  },

  computed: {
    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },

    PreviewCustomer() {
      return this.$store.getters["JobHub/PreviewCustomer"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>